<template>
  <div class="taoBao">
    <!-- 顶部大图片 -->
    <imgBigCards></imgBigCards>
    <!-- 输入框 -->
    <div class="box-input">
       <inputBox
        @query="queryList"
        v-model:inputValue="mydata.form.search"
        placeholder="请输入城市/书店名称"
      ></inputBox>
    </div>

    <!-- 模块2————按钮 和 搜索框 -->
    <div class="box-online1">
      <!-- 学科筛选按钮 -->
      <subjectButton
        :filterButton="mydata.filterButton1"
        @change="change1"
      ></subjectButton>
     
    </div>
    <!--模块3————内容  -->
    <div class="box-online2">
      <el-table
        :data="mydata.getOfflineArr"
        border
        style="width: 100%"
        header-row-class-name="my-table-header"
        row-class-name="my-table-row"
      >
        <el-table-column
          align="center"
          prop="province"
          label="省份"
          width="100"
        />
        <el-table-column align="center" prop="city" label="城市" width="130" />
        <el-table-column
          align="center"
          prop="store_name"
          label="店面名称"
          width="210"
        />
        <el-table-column
          align="center"
          prop="address"
          label="地址"
          width="300"
        />
        <!-- width="160"最后一列不要设置width了，全部宽度减去其他列的宽度就是它的宽度了，如果最后一列也设置了固定宽度，那么线条会出现问题 -->
        <el-table-column align="center" prop="tel" label="联系电话" width="170" />
      </el-table>
    </div>
    <!--分页 -->
      <div
        class="gl-pagination"
      >
        <el-pagination
          v-model:currentPage="mydata.pageObj.currentPage"
          v-model:page-size="mydata.pageObj.pageSize"
          :total="mydata.pageObj.total"
          layout="prev, pager, next"
        pager-count="4"
          @current-change="handleCurrentChange"
        />
      </div>
  </div>
</template>
  
<script>
// 缓存组件
// import { defineComponent } from "vue"
// export default defineComponent({
//   name: 'offlineAgent'
// });
</script>





  <script setup>
import imgBigCards from "@/components/imgBigCards/index.vue";
import inputBox from "@/components/inputBox/index.vue";
import subjectButton from "@/components/subjectButton/index.vue";
import bookBigListenCards from "@/components/bookBigListenCards/index.vue";
import thematicCards from "@/components/thematicCards/index.vue";
import { Document } from "@element-plus/icons-vue";

// import researchProjects from "@/components/researchProjects/index.vue";

import { reactive } from "vue";

// 引入线下店铺列表接口
import { getOfflineList } from "@/api/distributionAuthorization/offlineAgent/index.js";

import { useRouter } from "vue-router";

const router = useRouter();

const mydata = reactive({
  currentPage3: "5",
  pageSize3: "100",
  small: false,
  background: false,
  disabled: false,

  //筛选按钮
  filterButton1: {
    title: "地区",
    filter: JSON.parse(localStorage.getItem("searchList")).territory ?? [],
  },

  pageObj: {
    currentPage: 1, // 当前页数
    pageSize: 10, // 每页条数
    total: 0, // 总的条数
  },

  form: {
    // column_id: getUrlId(route.path), // 栏目id值
    search: "", // 搜索查询
    territory: "", //地域
  },

  getOfflineArr: [], // 线下店铺列表
});

// 当前页数改变事件
function handleCurrentChange(val) {
  // 查询
  getOfflineFn();
}


// 线下店铺列表
function getOfflineFn() {
  getOfflineList({
    ...mydata.form,
    page: String(mydata.pageObj.currentPage),
    psize: String(mydata.pageObj.pageSize),
  }).then((res) => {
    // 线下店铺列表
    mydata.getOfflineArr = res.data.list;
    // 总的条数
    mydata.pageObj.total = res.data.count;
  });
}

// 查询列表
function queryList(dict, inputValue) {
  // 分页变成第一页
  mydata.pageObj.currentPage = 1
  // 赋值
  mydata.form.search = inputValue;
  // 查询
  getOfflineFn();
}

// 地域单选改变事件
function change1(val) {
  // 赋值
  mydata.form.territory = val;
  // 查询
  getOfflineFn();
}

getOfflineFn();
</script>
  
<style scoped lang="scss">
.taoBao {
  background-color: #f9f9f9;
  // padding-bottom: 40px;
  //  ////////顶部大图片
  // > .big-img {
  //   width: 100%;
  //   height: 200px;
  //   // border:1px solid rgb(68, 0, 255);
  //   margin: 0 auto;
  // }
  // :deep(.box-img) {
  //   height: 200px;
  // }
  // //el-carousel元素
  // :deep(.el-carousel__container) {
  //   width: 100%;
  //   height: 200px;
  //   // padding:30px;
  // }
   ///////输入框
  .box-input {
    width: 100%;
    // height: 100px;
    //   // border: 1px solid red;
    background-color: #ffffff;
    // border:1px solid red;
    padding: 10px 0px;
    :deep(.inputBox) {
      margin: 0 auto;
      display: block;
      // border:1px solid red;
    }
    //////按钮消失一个
    :deep(.el-button.el-button--primary.box2) {
      display: none;
    }
  }
  //////模块2------按钮组件 和 搜索组件
  .box-online1 {
    background-color: #ffffff;
    margin: 0 auto;
    margin-top: 16px;
    margin-bottom: 16px;
    padding-top: 16px;
    padding-bottom: 16px;
    overflow: hidden;
    
  }
  ///////模块3
  .box-online2 {
    // width: 1200px;
    // height: 1010px;
    // border: 1px solid red;
    border-radius: 8px;
    padding: 16px;
    background-color: #ffffff;
    margin: 0 auto;
    // margin-top: 20px;
    // margin-bottom: 40px;
    overflow: hidden;
  }

  //////模块4————分页
  // .paging {
  //   // margin: 0 auto;
  //   margin-top: 40px;
  //   // margin-bottom: 40px;
  //   display: flex;
  //   justify-content: center;
  //   // border:1px solid red;

  //   :deep(.el-button.is-plain) {
  //     margin-left: 24px;
  //   }
  // }

  // .demo-pagination-block + .demo-pagination-block {
  //   margin-top: 10px;
  // }
  // .demo-pagination-block .demonstration {
  //   margin-bottom: 16px;
  // }

  /////表格
}

/** 表格头部 */
:deep(.my-table-header) {
  > th {
    background: #009de0 !important;
    border-color: #009de0 !important;
    height: 45px;
    border:none;
    > .cell {
      color: #f9f9f9;
      font-size: 16px;
      font-weight: 700;
      letter-spacing: 1px;
    }
  }
}

/** 表格身体 */
:deep(.my-table-row) {
  height: 20px;
  > td {
    border-color: #009de0 !important;
    > .cell {
      color: #333333;
      font-size: 13px;
      font-weight: 400;
    }
  }
}

/** 表格边线 */
:deep(.el-table__border-left-patch) {
  background-color: #009de0 !important;
}
:deep(.el-table--border .el-table__inner-wrapper:before) {
  background-color: #009de0 !important;
}
:deep(.el-table--border .el-table__inner-wrapper:after) {
  background-color: #009de0 !important;
}
:deep(.el-table--border:after) {
  background-color: #009de0 !important;
}
:deep(.el-table--border:before) {
  background-color: #009de0 !important;
}

:deep(.el-table__inner-wrapper) {
  overflow-x: auto;

  /* 针对webkit内核浏览器 */
  ::-webkit-scrollbar {
    display: none; /* 隐藏滚动条 */
  }

  /* 针对Firefox */
  scrollbar-width: none; /* Firefox中隐藏滚动条 */

  /* 针对IE和Edge */
  -ms-overflow-style: none; /* IE和Edge中隐藏滚动条 */
}
</style>
  